import { Injectable } from "@angular/core";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { AppConfig } from "../../../models/app-config";
import { AuthClientConfig, AuthConfig } from "@auth0/auth0-angular";
import config from "capacitor.config";
import { Platform } from "@ionic/angular";

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  private readonly CONFIG_URL = "assets/config/config.json";
  public config: AppConfig;
  handler: HttpBackend;
  isNative: boolean;

  constructor(
    handler: HttpBackend,
    private platform: Platform,
    private authClientConfig: AuthClientConfig
  ) {
    this.handler = handler;
    this.isNative = this.platform.is("hybrid");
  }

  public getConfigProperty(key: string): any {
    return this.config[key];
  }
  public getMapKey(): string {
    if (this.platform.is("hybrid")) {
      if (this.platform.is("android")) {        
        return this.config["GOOGLE_MAP_API_KEY_ANDROID"];
      }
      if (this.platform.is("ios")) {        
        return this.config["GOOGLE_MAP_API_KEY_IOS"];
      }
    }
    return this.config["GOOGLE_MAP_API_KEY"];
  }

  public async load(): Promise<any> {
    await this.loadConfigurations();
    this.loadAuthConfig();
  }

  private loadAuthConfig(): void {
    const authConfig = this.getAuthConfig();
    this.authClientConfig.set(authConfig);
  }

  /**
   * Returns Auth0 Angular SDK config. Must be called after load().
   */
  public getAuthConfig(): AuthConfig {
    if (!this.config?.auth0?.domain) {
      throw new Error("Auth0 config not loaded. Ensure load() has been called.");
    }
    const { appId } = config;
    const redirectUri = this.isNative
      ? `${appId}://${this.config.auth0.domain}/capacitor/${appId}/callback`
      : `${window.location.origin}/login-callback`;
    const authConfig: AuthConfig = {
      domain: this.config.auth0.domain,
      clientId: this.config.auth0.clientId,
      authorizationParams: {
        redirect_uri: redirectUri,
        audience: this.config.auth0.audience,
        scope: this.config.auth0.scope ?? "openid profile email",
      },
      cacheLocation: "localstorage",
      httpInterceptor: {
        allowedList: [
          {
            uri: `${this.config.API_URL}api/*`,
            tokenOptions: {
              authorizationParams: {
                audience: this.config.auth0.audience,
                scope: this.config.auth0.scope ?? "openid profile email",
              },
            },
          },
        ],
      },
    };
    return authConfig;
  }

  public async loadConfigurations(): Promise<any> {
    // TODO: do we want to not load config from a file in prod?
    // if that's the decision, then let's load everything from the environment
    console.log(`${window.location.origin}`);
    const client = new HttpClient(this.handler);
    const config = await firstValueFrom(client.get<AppConfig>(this.CONFIG_URL));
    this.config = config;
  }

}